module.exports = __webpack_public_path__ + "static/0069-44e83d9c47f6496741a8d3d93bc3ad85.png";